"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryProvinceAgeModel = exports.Currency = exports.Country = void 0;
var Country;
(function (Country) {
    Country["CA"] = "CA";
    Country["US"] = "US";
})(Country = exports.Country || (exports.Country = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(Currency = exports.Currency || (exports.Currency = {}));
exports.CountryProvinceAgeModel = {
    CA: {
        currency: Currency.CAD,
        name: 'Canada',
        provinceState: [
            {
                name: 'Alberta',
                code: 'AB',
                minimumAge: 18,
                timeZone: 'America/Edmonton'
            },
            {
                name: 'British Columbia',
                code: 'BC',
                minimumAge: 19,
                timeZone: 'America/Vancouver'
            },
            {
                name: 'Manitoba',
                code: 'MB',
                minimumAge: 18,
                timeZone: 'America/Winnipeg'
            },
            {
                name: 'New Brunswick',
                code: 'NB',
                minimumAge: 19,
                timeZone: 'America/Halifax'
            },
            {
                name: 'Newfoundland and Labrador',
                code: 'NL',
                minimumAge: 19,
                timeZone: 'America/St_Johns'
            },
            {
                name: 'Nova Scotia',
                code: 'NS',
                minimumAge: 19,
                timeZone: 'America/Halifax'
            },
            {
                name: 'Ontario',
                code: 'ON',
                minimumAge: 18,
                timeZone: 'America/Toronto'
            },
            {
                name: 'Prince Edward Island',
                code: 'PE',
                minimumAge: 19,
                timeZone: 'America/Halifax'
            },
            {
                name: 'Quebec',
                code: 'QC',
                minimumAge: 18,
                timeZone: 'America/Montreal'
            },
            {
                name: 'Saskatchewan',
                code: 'SK',
                minimumAge: 19,
                timeZone: 'America/Regina'
            },
            {
                name: 'Northwest Territories',
                code: 'NT',
                minimumAge: 19,
                timeZone: 'America/Yellowknife'
            },
            {
                name: 'Nunavut',
                code: 'NU',
                minimumAge: 19,
                timeZone: 'America/Iqaluit'
            },
            {
                name: 'Yukon',
                code: 'YT',
                minimumAge: 19,
                timeZone: 'America/Whitehorse'
            }
        ]
    },
    US: {
        currency: Currency.USD,
        name: 'United States',
        provinceState: [
            {
                code: 'AL',
                name: 'Alabama',
                minimumAge: 19,
                timeZone: 'America/New_York'
            },
            {
                name: 'Alaska',
                code: 'AK',
                minimumAge: 18,
                timeZone: 'US/Alaska'
            },
            {
                name: 'Arizona',
                code: 'AZ',
                minimumAge: 21,
                timeZone: 'America/Denver'
            },
            {
                name: 'Arkansas',
                code: 'AR',
                minimumAge: null,
                timeZone: 'America/Chicago'
            },
            {
                name: 'California',
                code: 'CA',
                minimumAge: 18,
                timeZone: 'America/Los_Angeles'
            },
            {
                name: 'Colorado',
                code: 'CO',
                minimumAge: 18,
                timeZone: 'America/Denver'
            },
            {
                name: 'Connecticut',
                code: 'CT',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'District of Columbia',
                code: 'DC',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Delaware',
                code: 'DE',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Florida',
                code: 'FL',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Georgia',
                code: 'GA',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Hawaii',
                code: 'HI',
                minimumAge: null,
                timeZone: 'Pacific/Honolulu'
            },
            {
                name: 'Idaho',
                code: 'ID',
                minimumAge: 18,
                timeZone: 'America/Los_Angeles'
            },
            {
                name: 'Illinois',
                code: 'IL',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Indiana',
                code: 'IN',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Iowa',
                code: 'IA',
                minimumAge: null,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Kansas',
                code: 'KS',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Kentucky',
                code: 'KY',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Louisiana',
                code: 'LA',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Maine',
                code: 'ME',
                minimumAge: 16,
                timeZone: 'America/New_York'
            },
            {
                name: 'Maryland',
                code: 'MD',
                minimumAge: 16,
                timeZone: 'America/New_York'
            },
            {
                name: 'Massachusetts',
                code: 'MA',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Michigan',
                code: 'MI',
                minimumAge: 18,
                timeZone: 'America/Detroit'
            },
            {
                name: 'Minnesota',
                code: 'MN',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Mississippi',
                code: 'MS',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Missouri',
                code: 'MO',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Montana',
                code: 'MT',
                minimumAge: 16,
                timeZone: 'America/Denver'
            },
            {
                name: 'Nebraska',
                code: 'NE',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Nevada',
                code: 'NV',
                minimumAge: 21,
                timeZone: 'America/Los_Angeles'
            },
            {
                name: 'New Hampshire',
                code: 'NH',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'New Jersey',
                code: 'NJ',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'New Mexico',
                code: 'NM',
                minimumAge: null,
                timeZone: 'America/Denver'
            },
            {
                name: 'New York',
                code: 'NY',
                minimumAge: null,
                timeZone: 'America/New_York'
            },
            {
                name: 'North Carolina',
                code: 'NC',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'North Dakota',
                code: 'ND',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Ohio',
                code: 'OH',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Oklahoma',
                code: 'OK',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Oregon',
                code: 'OR',
                minimumAge: 18,
                timeZone: 'America/Los_Angeles'
            },
            {
                name: 'Pennsylvania',
                code: 'PA',
                minimumAge: null,
                timeZone: 'America/New_York'
            },
            {
                name: 'Rhode Island',
                code: 'RI',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'South Carolina',
                code: 'SC',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'South Dakota',
                code: 'SD',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Tennessee',
                code: 'TN',
                minimumAge: null,
                timeZone: 'America/New_York'
            },
            {
                name: 'Texas',
                code: 'TX',
                minimumAge: 18,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Utah',
                code: 'UT',
                minimumAge: null,
                timeZone: 'America/Denver'
            },
            {
                name: 'Vermont',
                code: 'VT',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Virginia',
                code: 'VA',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Washington',
                code: 'WA',
                minimumAge: 18,
                timeZone: 'America/Los_Angeles'
            },
            {
                name: 'West Virginia',
                code: 'WV',
                minimumAge: 18,
                timeZone: 'America/New_York'
            },
            {
                name: 'Wisconsin',
                code: 'WI',
                minimumAge: null,
                timeZone: 'America/Chicago'
            },
            {
                name: 'Wyoming',
                code: 'WY',
                minimumAge: 18,
                timeZone: 'America/Denver'
            }
        ]
    }
};
//# sourceMappingURL=data:application/json;base64,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